import axios from "axios"
import { getBackendUrl } from "./general"


export const obtenerSeguimientosUsuario = async (context, idEmployee) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/mercadeo/api/dataSeguimientos/${idEmployee}`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataKPIDirectoryQuatity = async (context, data) => {
  try {
    await context.$store.dispatch("statusLogin", context.$router);

    const { source } = await getBackendUrl();
    const result = await axios.post(
      `${source}/consultas/api/dataKPICantidadesDirectorio`,
      data,
      {
        headers: {
          "Authorization": `Bearer ${context.$store.state.user.token}`
        }
      }
    );

    return result.data;
  } catch(err) {
    console.log(err);
    throw err.response;
  }
}


export const dataKPIDocumentValues = async (context, firstDate, lastDate, typeQuery, idStaffGroup, idEmployee) => {
  try {
    await context.$store.dispatch("statusLogin", context.$router);

    const { source } = await getBackendUrl();
    const result = await axios.post(
      `${source}/consultas/api/dataKPIValoresDocumento`,
      {
        "Fecha_Inicial": firstDate,
        "Fecha_Final": lastDate,
        "Tipo_Consulta": typeQuery,
        "Id_GrupoEmpleado": idStaffGroup,
        "Id_Empleado": idEmployee
      },
      {
        headers: {
          "Authorization": `Bearer ${context.$store.state.user.token}`
        }
      }
    );

    return result.data;
  } catch (err) {
    console.log(err);
    throw err.response;
  }
}


export const dataDashboardAdministracion = async (context, fechaInicial, fechaFinal, idGrupoPersonal, idEmpleado) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)

    const { source } = await getBackendUrl()
    const res = await axios.post(
      `${source}/consultas/api/dataDashboardAdministracion`,
      {
        "Fecha_Inicial": fechaInicial,
        "Fecha_Final": fechaFinal,
        "Id_GrupoPersonal": idGrupoPersonal,
        "Id_Vendedor": idEmpleado
      },
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )

    // const res = await axios.get(
    //   `${source}/consultas/api/dataDashboardAdministracion/${idDirectory}/dataGridDependencias/${path}`,
    //   {
    //     headers: {
    //       'Authorization': `Bearer ${context.$store.state.user.token}`
    //     }
    //   }
    // )

    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataCarteraEdades = async (
  context,
  reportType,
  portfolioDays,
  idStaffGroup,
  idEmployee,
  idDirectory
) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.post(
      `${source}/consultas/api/dataCarteraEdades`,
      {
        Tipo_Reporte: reportType,
        Dias_Cartera: portfolioDays,
        Id_GrupoPersonal: idStaffGroup,
        Id_Empleado: idEmployee,
        Id_Directorio: idDirectory
      },
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataEfectividadCotizacionesVendedores = async (
  context,
  initDate,
  endDate,
  idEmployee
) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.post(
      `${source}/consultas/api/dataEfectividadCotizacionesVendedores`,
      {
        Fecha_Inicial: initDate,
        Fecha_Final: endDate,
        Id_Empleado: idEmployee
      },
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )

    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

// export const dataCantidadClientesVendedores = async (
//   context,
//   state,
//   idEmployee
// ) => {
//   try {
//     await context.$store.dispatch('statusLogin', context.$router)
//     const { source } = await getBackendUrl()
//     const res = await axios.post(
//       `${source}/consultas/api/dataCantidadClientesVendedores`,
//       {
//         Estado: state,
//         Id_Empleado: idEmployee
//       },
//       {
//         headers: {
//           'Authorization': `Bearer ${context.$store.state.user.token}`
//         }
//       }
//     )

//     return res.data
//   } catch (err) {
//     console.log(err)
//     throw err.response
//   }
// }

export const dataCostoVentasDocumentos = async (
  context,
  initDate,
  endDate,
  reportType,
  utilityType,
  idEmployeeGroup,
  idEmployee
) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)

    const { source } = await getBackendUrl()
    const res = await axios.post(
      `${source}/consultas/api/dataCostoVentasDocumentos`,
      {
        Fecha_Inicial: initDate,
        Fecha_Final: endDate,
        Tipo_Reporte: reportType,
        Tipo_Utilidad: utilityType,
        Id_GrupoPersonal: idEmployeeGroup,
        Id_Personal: idEmployee
      },
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )

    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataCostoVentasKardex = async (
  context,
  initDate,
  endDate,
  reportType,
  utilityType,
  idCity,
  idEmployeeGroup,
  idEmployee,
  idDirectory,
  idCategory,
  idBrand
) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)

    const { source } = await getBackendUrl()
    const res = await axios.post(
      `${source}/consultas/api/dataCostoVentasKardex`,
      {
        Fecha_Inicial: initDate,
        Fecha_Final: endDate,
        Tipo_Reporte: reportType,
        Tipo_Utilidad: utilityType,
        Id_Ciudad: idCity,
        Id_GrupoPersonal: idEmployeeGroup,
        Id_Personal: idEmployee,
        Id_Directorio: idDirectory,
        Id_Categoria: idCategory,
        Id_Marca: idBrand
      },
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )

    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataGridMovimientosPedido = async (context, idOrder) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)

    const { source } = await getBackendUrl()
    const res = await axios.post(
      `${source}/consultas/api/dataPedidoMovimientos`,
      {
        "Id_Pedido": idOrder,
        "Tipo_Datos": "M"
      },
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )

    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataSeguimientoCotizacion = async (context, idQuote) => {
  try {
    await context.$store.dispatch("statusLogin", context.$router)

    const { source } = await getBackendUrl()
    const result = await axios.get(
      `${source}/consultas/api/dataSeguimientoCotizacion?id=${idQuote}`,
      {
        headers: {
          "Authorization": `Bearer ${context.$store.state.user.token}`
        }
      }
    )

    return result.data
  } catch (err) {
    console.log(err);
    throw err.response
  }
}

export const dataEventosDocumentoElectronico = async (context, uuid) => {
  try {
    console.log(context.$router);
    
    await context.$store.dispatch("statusLogin", context.$router);

    const { source } = await getBackendUrl();
    const parameters = {
      "UUID": uuid
    }
    const response = await axios.get(
      `${source}/consultas/api/consultaEventosDocumentoElectronico`,
      {
        params: parameters,
        headers: {
          "Authorization": `Bearer ${context.$store.state.user.token}`
        }
      }
    );

    return response.data;
  } catch (err) {
    throw err.response;
  }
}
